<template>
  <div v-if="isShow.isKVShow" class="pg-kv">
    <div class="kv-logo"></div>
    <div class="kv-left">
      <div class="kv-lf1 transTop"></div>
      <div class="kv-lf2 transTop"></div>
    </div>
    <div class="title-wp">
      <div class="title-top">
        <div class="title-bg1"></div>
        <div class="title-bg2 titleTrans">
          <div class="title1-wp">
            <div class="title1"></div>
            <div class="title100 scaleIt"></div>
          </div>
          <div class="title2"></div>
        </div>
      </div>
      <div class="title-bottom">
        <div class="title-txt-bottom"></div>
        <div class="title-txt-top">昌江正在争创全国文明城市</div>
      </div>
    </div>
    <div class="kv-desc"></div>
    <div class="kv-slider">
      <div class="slider-txt">向右滑动</div>
      <div class="progress" :style="moveStyle2"></div>
      <div
        class="flower-wp"
        :style="moveStyle"
        @touchstart="handleStart"
        @touchmove="handleMove"
        @touchend="handleEnd"
      >
        <div class="flower1"></div>
      </div>
      <div class="flower2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: Object,
  },
  data() {
    return {
      startX: 0,
      diffX: 0,
      moveStyle: {
        transform: 'translateX(0)',
      },
      moveStyle2: {
        transform: 'scaleX(1)',
      },
    }
  },
  components: {},
  methods: {
    showNext() {
      this.$emit('playMusic', 'm1')
      this.$emit('nextPage', 'isPOShow')
    },
    handleStart(evt) {
      this.startX = evt['touches'][0].clientX
    },
    handleMove(evt) {
      const curX = evt['touches'][0].clientX
      const diff = curX - this.startX
      if (diff < 0) {
        return
      } else if (diff > 183) {
        this.showNext()
        return
      } else {
        this.moveStyle = {
          transform: `translateX(${diff}px)`,
        }
        this.moveStyle2 = {
          transform: `scaleX(${1 - Math.floor((diff / 183) * 1000) / 1000})`,
        }
      }
    },
    handleEnd() {
      this.startX = 0
      this.moveStyle = {
        transform: 'translateX(0)',
      }
      this.moveStyle2 = {
        transform: 'scaleX(1)',
      }
    },
  },
  created() {
    // this.fetchData();
  },
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg-kv {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #ffe400;
  overflow: hidden;
}
.kv-logo {
  position: absolute;
  left: 5rem;
  top: 1.5rem;
  width: 8.375/2rem /* 134/16 */;
  height: 3.8125/2rem /* 61/16 */;
  .bg('./img/kv-logo.png');
}
.kv-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 8.75/2rem /* 140/16 */;
  height: 100%;
  overflow: hidden;
  .kv-lf1 {
    width: 8.75/2rem /* 140/16 */;
    height: 149.3125/2rem /* 2389/16 */;
    .bg('./img/kv-left.jpg');
  }
  .kv-lf2 {
    width: 8.75/2rem /* 140/16 */;
    height: 149.3125/2rem /* 2389/16 */;
    .bg('./img/kv-left.jpg');
  }
}
.title-wp {
  position: relative;
  width: 18.75rem /* 300/16 */;
  height: 29.375/2rem /* 470/16 */;
}
.title-bg1 {
  width: 36.875/2rem /* 590/16 */;
  height: 28.75/2rem /* 460/16 */;
  border-radius: 20px;
  border: 1px solid #333;
  background-color: #ffcc35;
  background-image: linear-gradient(#d2a82c 1px, transparent 0),
    linear-gradient(to right, #d2a82c 1px, transparent 0);
  background-size: 10px 10px;
}
.title-bg2 {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  width: 36.875/2rem /* 590/16 */;
  height: 28.75/2rem /* 460/16 */;
  padding: 2.25rem /* 36/16 */ 1.125rem /* 18/16 */;
  border-radius: 20px;
  border: 1px solid #333;
  background-color: #fff;
}
.title1-wp {
  position: relative;
}
.title1 {
  width: 31.375/2rem /* 502/16 */;
  height: 12.8125/2rem /* 205/16 */;
  .bg('./img/kv-title1.png');
  background-size: contain;
}
.title100 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 16.5625/2rem /* 265/16 */;
  height: 7.4375/2rem /* 119/16 */;
  .bg('./img/kv-100.png');
  background-size: contain;
}
.title2 {
  position: relative;
  width: 31.4375/2rem /* 503/16 */;
  height: 5.5/2rem /* 88/16 */;
  margin-top: 1.5rem;
  .bg('./img/kv-title2.png');
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: -0.75rem;
    height: 1px;
    background-color: #333;
    transform: scaleY(0.5);
  }
}
.title-bottom {
  position: relative;
  margin-top: 0.8rem;
}
.title-txt-bottom {
  width: 100%;
  height: 3.125/2rem /* 50/16 */;
  background-color: #34302f;
}
.title-txt-top {
  position: absolute;
  top: -0.2rem;
  left: -0.2rem;
  width: 100%;
  height: 3.125/2rem /* 50/16 */;
  box-sizing: border-box;
  border: 1px solid #34302f;
  background-color: #fd8603;
  color: white;
  font-size: 0.875rem /* 14/16 */;
  letter-spacing: 1px;
  line-height: 3.125/2rem /* 50/16 */;
  text-align: center;
}
.kv-desc {
  margin-top: 3.6rem;
  width: 28.0625/2rem /* 449/16 */;
  height: 16.875/2rem /* 270/16 */;
  .bg('./img/kv-txt.png');
}
.kv-slider {
  margin-top: 7rem;
  position: relative;
  .slider-txt {
    position: absolute;
    top: -1.4rem;
    left: 50%;
    margin-left: 0.4rem;
    color: #ff5917;
    font-size: 0.75rem /* 12/16 */;
    transform: translateX(-50%);
  }
  .progress {
    position: relative;
    width: 9.0625rem /* 145/16 */;
    height: 0.625/2rem /* 10/16 */;
    background-color: #ffcc58;
    border: 1px dashed white;
    transform-origin: right;
  }
  .flower-wp {
    position: absolute;
    left: -2.5rem /* 40/16 */;
    top: -1rem;
    width: 5.75/2rem /* 92/16 */;
    height: 4.75/2rem /* 76/16 */;
    z-index: 3;
  }
  .flower1 {
    width: 5.75/2rem /* 92/16 */;
    height: 4.75/2rem /* 76/16 */;
    .bg('./img/kv-flower-full.png');
    animation: scaleIt 1s ease-in-out infinite;
  }
  .flower2 {
    position: absolute;
    right: -2.5rem /* 40/16 */;
    top: -1rem;
    width: 5.4375/2rem /* 87/16 */;
    height: 4.5625/2rem /* 73/16 */;
    .bg('./img/kv-flower-empty.png');
  }
}
@keyframes scaleIt {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}
.titleTrans {
  animation: titleTrans 0.5s ease-in both;
}
@keyframes titleTrans {
  from {
    transform: translate(0, 0);
  }
  to {
    transform: translate(-10px, -10px);
  }
}
.transTop {
  animation: transTop 16s linear infinite;
}
@keyframes transTop {
  from {
    transform: translateZ(0) translateY(0);
  }
  to {
    transform: translateZ(0) translateY(-100%);
  }
}
.scaleIt {
  animation: scaleIt 0.8s ease-in 0.5s both;
}
@keyframes scaleIt {
  0%,
  100% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
}
</style>
